import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.user.search.adminSortFields,
	columnFields: constants.user.search.adminColumnFields,
	standardFilterFields: constants.user.search.adminFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: constants.user.search.adminFilterBooleanFields,
});
